<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-dropdown
    [dt]="props.dt"
    #dropdown
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [options]="props.options | formlySelectOptions: field | async"
    [optionLabel]="props.optionLabel ?? 'label'"
    [optionValue]="props.optionValue ?? 'value'"
    [group]="props.group ?? false"
    [optionGroupLabel]="props.optionGroupLabel ?? 'label'"
    [optionGroupChildren]="props.optionGroupChildren ?? 'items'"
    [label]="props.label"
    [filter]="true"
    filterBy="label"
    [showClear]="!props.required"
    [required]="props.required"
    [readonly]="props.readonly"
    [isVertical]="props.isVertical"
    [badgeDisabled]="props.badgeDisabled"
    [showDashIfEmptyAndReadOnly]="props.showDashIfEmptyAndReadOnly"
    [prePopulateSingleOption]="to.prePopulateSingleOption"
    (changed)="props.change && props.change(field, $event)"
  >
    @if (props.showFlag) {
      <ng-template #valueAddon let-value>
        @if (value) {
          <new-ui-flag [country]="value" [small]="true" />
        }
      </ng-template>

      <ng-template #item #selectedItem let-item>
        <div class="row">
          <new-ui-flag [country]="dropdown.getOptionValue(item)" [small]="true" />
          <span>{{ dropdown.getOptionLabel(item) }}</span>
        </div>
      </ng-template>
    }
  </new-ui-dropdown>

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
